import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Ride_In_Comfort from "./ride-in-comfort/Ride_In_Comfort";
import Where_You_Are_Going from "./where-you-are-going/Where_You_Are_Going";
import Our_Achievements from "./our-achievements/Our_Achievements";
import Top_Destinations from "./top-destinations/Top_Destinations";
import Book_A_Ride from "./book-a-ride/Book_A_Ride";
import Why_Choose_Us from "./why-choose-us/Why_Choose_Us";
import Testimonials from "./testimonials/Testimonials";
import Blogs_Section from "./blogs-section/Blogs_Section";

function Home() {
  return (
    <>
      <Banner />
      <Ride_In_Comfort />
      <Where_You_Are_Going />
      <Our_Achievements />
      <Top_Destinations />
      <Book_A_Ride />
      <Why_Choose_Us />
      <Testimonials />
      <Blogs_Section />
    </>
  );
}

export default Home;
